<template>
    <div class="detail-wrapper">
        <div class="left">
            <div class="info">
                <img :src="state.info.avatarUrl && state.info.avatarUrl.length > 0 ? state.info.avatarUrl.length : state.defaultAvatar"
                    alt="">
                <div class="name">
                    {{ state.info.realName ?? '-' }}
                </div>
                <div class="phone">
                    {{ state.info.mobile ?? '-' }}
                </div>
            </div>
            <div class="click-record">
                <div class="title">
                    <el-icon>
                        <List />
                    </el-icon>
                    {{ t('personnelDetail.recentCheckin') }}
                </div>
                <div class="record">
                    <el-empty v-if="state.clickRecord.length == 0" :description="t('personnelDetail.noData')" :image-size="80" />
                    <el-timeline v-else>
                        <el-timeline-item v-for="(item, index) in state.clickRecord" :key="index"
                            :timestamp="`${item.contents}  ${formatDisplayDateTime(item.checkin_time) || '-'}`">
                        </el-timeline-item>
                    </el-timeline>
                </div>
            </div>
            <div class="points-record">
                <div class="title">
                    <el-icon>
                        <List />
                    </el-icon>
                    {{ t('personnelDetail.recentPoints') }}
                </div>
                <div class="record">
                    <el-empty v-if="state.pointsRecord.length == 0" :description="t('personnelDetail.noData')" :image-size="80" />
                    <el-timeline v-else>
                        <el-timeline-item v-for="(item, index) in state.pointsRecord" :key="index"
                            :timestamp="item.checkin_time">
                            <span :style="{ color: item.change_type === 1 ? '#67C23A' : '#F56C6C' }">{{ item.change_type
                                === 1 ? '+' : '-' }}{{ item.points }}</span>
                            （{{ item.reason }}）
                        </el-timeline-item>
                    </el-timeline>
                </div>
            </div>
        </div>
        <div class="right">
            <div class="overview">
                <div class="item border-right">
                    <span><span class="number">{{ state.info.points }}</span></span>
                    <span class="text">{{ t('personnelDetail.points') }}</span>
                </div>
                <div class="item border-right">
                    <span><span class="number">{{ state.overview.goToWork }}</span>天</span>
                    <span class="text">{{ t('personnelDetail.monthCheckinDays') }}</span>
                </div>
                <div class="item border-right">
                    <span><span class="number">{{ state.overview.otDay }}</span>天</span>
                    <span class="text">{{ t('personnelDetail.monthOtDays') }}</span>
                </div>
                <div class="item border-right">
                    <span><span class="number">{{ state.overview.otTime }}</span>小时</span>
                    <span class="text">{{ t('personnelDetail.monthOtHours') }}</span>
                </div>
                <div class="item border-right">
                    <span><span class="number">{{ state.overview.zhiDay }}</span>天</span>
                    <span class="text">{{ t('personnelDetail.monthZhiDays') }}</span>
                </div>
                <div class="item">
                    <span><span class="number">{{ state.overview.zhiTime }}</span>小时</span>
                    <span class="text">{{ t('personnelDetail.monthZhiHours') }}</span>
                </div>
            </div>
            <div class="my-special" ref="myElementRef">
                <el-tabs type="border-card">
                    <el-tab-pane :label="t('personnelDetail.tabMachinist')">
                        <div ref="searchBox">
                            <hc-search :data="searchData" @serch="getSearch">
                                <template #btns>
                                    <el-button type="primary" icon="Plus"
                                        @click="$refs['bindUser'].open(route.query.id)">关联机手</el-button>
                                </template>
                            </hc-search>
                        </div>
                        <!-- 表格 -->
                        <div class="table_box">
                            <hc-table :tableData="state.userTableData" :column="state.userTableHeader"
                                :loading="state.userTableLoading" :offsetHeight="state.offsetHeight" :maxPage="maxPage" @pageChange="pageChange"
                                @limitChange="limitChange">
                                <template #employment="{ row }">
                                    {{ listToMap(employmentOptions, {})[row.employment] }}
                                </template>
                                <template #login_time="{ row }">
                                    {{ formatDisplayDateTime(row.login_time) || '-' }}
                                </template>
                                <template #start_date="{ row }">
                                    {{ formatDisplayDate(row.start_date) || '-' }}
                                </template>
                                <template #end_date="{ row }">
                                    {{ formatDisplayDate(row.end_date) || '-' }}
                                </template>
                                <template #operation="scope">
                                    <div class="btn_box_det">
                                        <el-button class="opBtn" size="small" type="danger" link
                                            @click="unbind(scope.row)">解除</el-button>
                                    </div>
                                </template>
                            </hc-table>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="设备">
                        <div ref="searchBox">
                            <hc-search :data="eqptSearchData" @serch="getEqptSearch">
                                <template #btns>
                                    <el-button type="primary" icon="Plus" @click="$refs['bindMachine'].open()">绑定设备</el-button>
                                </template>
                            </hc-search>
                        </div>
                        <!-- 表格 -->
                        <div class="table_box">
                            <hc-table :tableData="state.eqptTableData" :column="state.eqptTableHeader"
                                :loading="state.eqptTableLoading" :offsetHeight="state.offsetHeight" :maxPage="maxPage" @pageChange="pageChange"
                                @limitChange="limitChange">
                                <template #status="{ row }">
                                    {{ listToMap(statusOptions, {})[row.status] }}
                                </template>
                                <template #operation="scope">
                                    <div class="btn_box_det">
                                        <el-button size="small" class="opBtn" type="danger" link
                                            @click="deleteBind(scope.row)">解绑</el-button>
                                    </div>
                                </template>
                            </hc-table>
                        </div>
                    </el-tab-pane>
                   
                </el-tabs>
            </div>
        </div>

        <BindMachine ref="bindMachine" :user_id="state.info.id" @refresh="getEqptSearch(searchData)" />

        <BindUser ref="bindUser" :user_id="state.info.id" @refresh="getSearch(searchData)" />
    </div>
</template>

<script setup>
import {
    onMounted,
    reactive,
    ref,
    nextTick,
    defineEmits,
    defineProps,
    defineExpose,
    toRaw
} from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage, ElMessageBox } from "element-plus";
import { List } from '@element-plus/icons-vue'
import { getUerInfoAPi, getClickRecordApi, getOverviewApi, getPointsRecordApi, getUserDeviceListApi, delBindApi } from "@/api/machinist/detail.js";
import { pageListApi, unbindApi } from "@/api/system/bindUser";
import hcSearch from "@/components/hc-search/index.vue";
import hcTable from "@/components/hc-table/index.vue";
import { listToMap } from "@/utils/utils";
import { formatDisplayDate, formatDisplayDateTime } from "@/utils/dateTime.js";
import BindUser from "./components/bindUser.vue";
import BindMachine from "../machinist/components/bindMachine.vue";
import { t } from "@/composables/usePageI18n.js";
const emit = defineEmits([]);

const router = useRouter();
const route = useRoute();

const myElementRef = ref();
const searchBox = ref();
const bindUser = ref();
const bindMachine = ref();


let page = ref(1);
let limit = ref(20);
let maxPage = ref(0);
const statusOptions = reactive([
    { label: "启用", value: 1 },
    { label: "停用", value: 0 }
])

const employmentOptions = reactive([
    { label: "在职", value: 1 },
    { label: "离职", value: 0 },
])

const sexOptions = reactive([
    { label: "未知", value: 0 },
    { label: "男", value: 1 },
    { label: "女", value: 2 }
])

const eqptSearchData = reactive([
    {
        label: "关键词",
        type: "input",
        value: "",
        field: 'keywords'
    },
]);

const searchData = reactive([
    {
        label: "关键词",
        type: "input",
        value: "",
        field: 'keywords'
    },
]);
const state = reactive({
    dialogVisible: false,
    info: {

    },
    defaultAvatar: require('@/assets/user/avatar.png'),
    clickRecord: [
    ],
    pointsRecord: [
        // {
        //     "reason": "技能学习：测试任务2",
        //     "user_id": 3,
        //     "mobile": "13333333333",
        //     "created_at": "2025-05-31 15:35:12",
        //     "change_type": 1,
        //     "real_name": "玩大锤",
        //     "id": 7,
        //     "points": 1,
        //     "username": "wdc"
        // },
        // {
        //     "reason": "技能学习：测试技能提升 任务",
        //     "user_id": 3,
        //     "mobile": "13333333333",
        //     "created_at": "2025-05-31 15:33:28",
        //     "change_type": 1,
        //     "real_name": "玩大锤",
        //     "id": 6,
        //     "points": 5,
        //     "username": "wdc"
        // },
        // {
        //     "reason": "技能学习：测试任务2",
        //     "user_id": 7,
        //     "mobile": "16666666666",
        //     "created_at": "2025-05-31 15:31:28",
        //     "change_type": 1,
        //     "real_name": "王路飞",
        //     "id": 5,
        //     "points": 1,
        //     "username": "wlf"
        // },
        // {
        //     "reason": "技能学习：测试技能提升 任务",
        //     "user_id": 3,
        //     "mobile": "13333333333",
        //     "created_at": "2025-05-31 15:31:22",
        //     "change_type": 1,
        //     "real_name": "玩大锤",
        //     "id": 4,
        //     "points": 5,
        //     "username": "wdc"
        // },
        // {
        //     "reason": "完成特殊任务：第二个特殊任务",
        //     "user_id": 7,
        //     "mobile": "16666666666",
        //     "created_at": "2025-05-30 17:27:00",
        //     "change_type": 1,
        //     "real_name": "王路飞",
        //     "id": 3,
        //     "points": 20,
        //     "username": "wlf"
        // },
        // {
        //     "reason": "完成特殊任务：测试发布人参数",
        //     "user_id": 3,
        //     "mobile": "13333333333",
        //     "created_at": "2025-05-21 22:50:26",
        //     "change_type": 1,
        //     "real_name": "玩大锤",
        //     "id": 2,
        //     "points": 1,
        //     "username": "wdc"
        // },
        // {
        //     "reason": "技能学习",
        //     "user_id": 1,
        //     "mobile": "13456214521",
        //     "created_at": "2025-05-08 19:38:41",
        //     "change_type": 1,
        //     "real_name": "张三",
        //     "id": 1,
        //     "points": 10,
        //     "username": "jishou0001"
        // }
    ],
    overview: {},
    userTableLoading: false,
    eqptTableLoading: false,
    flag: true,
    offsetHeight: 0,
    eqptTableHeader: [],
    userTableHeader: [],
    eqptTableData: [
        // {
        //   "password": "123456",
        //   "updated_at": "2025-05-07 14:21:31",
        //   "role_id": listToMap(roleOptions)[1],
        //   "sex": listToMap(sexOptions)[1],
        //   "mobile": "13456214521",
        //   "created_at": "2025-05-07 14:21:31",
        //   "real_name": "张三",
        //   "id": 1,
        //   "email": "14253658@qq.com",
        //   "username": "jishou0001",
        //   "points": 0,
        //   "status": listToMap(statusOptions)[1],
        // }
    ],
    eqptColumn: [
        {
            prop: "id",
            show: false,
            label: "任务ID",
        },
        {
            // prop: "id",
            show: true,
            type: "index",
            label: "序号",
            width: 80,
        },
        {
            prop: "code",
            show: true,
            label: "编码",
        },
        {
            prop: "title",
            show: true,
            label: "设备名称",
        },
        {
            prop: "kilometer",
            show: true,
            label: "公里数",
        },
        {
            prop: "status",
            show: true,
            label: "状态",
        },
        {
            prop: "operation",
            show: true,
            label: "操作",
            width: 100
        },
    ],
    userColumn: [
        // {
        //     type: 'selection',
        //     width: 50
        // },
        {
            prop: "id",
            show: false,
            label: "编码",
        },
        {
            // prop: "id",
            show: true,
            type: "index",
            label: "序号",
            width: 80,
        },
        {
            prop: "real_name",
            show: true,
            label: "姓名",
            width: 100
        },
        {
            prop: "english_name",
            show: true,
            label: "英文名",
            width: 100
        },
        {
            prop: "id_card",
            show: true,
            label: "身份号码",
            width: 160
        },
        {
            prop: "sex",
            show: true,
            label: "性别",
            width: 80
        },
        {
            prop: "username",
            show: true,
            label: "用户名",
            width: 120
        },
        {
            prop: "password",
            show: true,
            label: "密码",
            width: 160
        },
        {
            prop: "email",
            show: true,
            label: "邮箱",
            width: 180
        },

        {
            prop: "address",
            show: true,
            label: "家庭住址",
            width: 200
        },
        {
            prop: "start_date",
            show: true,
            label: "入职时间",
            width: 160
        },
        {
            prop: "end_date",
            show: true,
            label: "离职时间",
            width: 160
        },
        {
            prop: "employment",
            show: true,
            label: "在职状态",
            width: 100
        },
        {
            prop: "mobile",
            show: true,
            label: "手机",
            width: 160
        },
        {
            prop: "points",
            show: true,
            label: "分数",
            width: 80
        },
        {
            prop: "status",
            show: true,
            label: "状态",
            width: 80
        },
        {
            prop: "login_time",
            show: true,
            label: "最近登录时间",
            width: 160
        },
        // {
        //     prop: "updated_at",
        //     show: true,
        //     label: "更新时间",
        //     width: 160
        // },
        {
            prop: "operation",
            show: true,
            label: "操作",
            width: 100
        },
    ],
    userTableData: []
});

const getPersonDetail = () => {
    const params = JSON.stringify({
        id: route.query.id
    })
    getUerInfoAPi(params).then(res => {
        if (res?.code === 200) {
            state.info = res?.data ?? {};
        }
    })
}

const getClickRecord = () => {
    const date = new Date()
    const params = JSON.stringify({
        "time": `${date.getFullYear()}-${date.getMonth() + 1}`,
        "user_id": route.query.id
    })
    getClickRecordApi(params).then(res => {
        if (res?.code === 200) {
            if (!res?.data || res.data.length == 0) {
                state.clickRecord = []
                return
            }
            const filterList = filterHasRecordData(res.data)
            if (filterList < 3) {
                let list = []
                filterList.forEach(item => {
                    item.goToWork[0] && list.push(item.goToWork[0])
                    item.goOffWork[0] && list.push(item.goOffWork[0])
                    list.concat([...item.workOvertime])
                });
                state.clickRecord = list
            } else {
                let list = []
                filterList.slice(-3).forEach(item => {
                    item.goToWork[0] && list.push(item.goToWork[0])
                    item.goOffWork[0] && list.push(item.goOffWork[0])
                    list.concat([...item.workOvertime])
                });
                state.clickRecord = list
            }
        }
    })
}

// 过滤出有打卡记录的数据
const filterHasRecordData = (arr) => {
    return arr.filter(item => {
        return item.goToWork.length > 0 || item.goOffWork.length > 0 || item.workOvertime.length > 0
    })
}

const getOverview = () => {
    const date = new Date()
    const month = date.getMonth() + 1
    const params = JSON.stringify({
        "time": `${date.getFullYear()}-${month < 10 ? '0' + month : month}`,
        "user_id": route.query.id
    })
    getOverviewApi(params).then(res => {
        if (res?.code === 200) {
            state.overview = res?.data ?? {};
        }
    })
}

const getPointsRecord = () => {
    const params = JSON.stringify({
        "page": 1,
        "user_id": route.query.id
    })
    getPointsRecordApi(params).then(res => {
        if (res?.code === 200) {
            state.pointsRecord = res?.data ?? [];
        }
    })
}

const deleteBind = (row) => {
    ElMessageBox.confirm(
        `确认要解除绑定[${row.title}]吗?`,
        '提示',
        {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }
    )
        .then(() => {
            const params = JSON.stringify({
                id: row.id
            })
            delBindApi(params).then(res => {
                if (res?.code === 200) {
                    ElMessage.success(res?.msg ?? '解绑成功')
                    getEqptSearch(eqptSearchData)
                }
            })
        })
        .catch(() => {

        })
}

const unbind = (row) => {
    ElMessageBox.confirm(
        `是否解除机手【${row.real_name}】的关联？`,
        '提示',
        {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }
    )
        .then(() => {
            // 这里可以添加取消绑定的逻辑
            const params = {
                "d_id": route.query.id,
                "u_id": row.id
            }
            unbindApi(params).then(res => {
                if (res.code == 200) {
                    ElMessage.success(res.msg)
                }
                getSearch(searchData)
            })
        })
        .catch(() => {

        })
};

const init = () => {
    getPersonDetail()
    getClickRecord()
    getOverview()
    getPointsRecord()
    getEqptSearch(eqptSearchData)
    getSearch(searchData)
};

// 动态改变表头
const change = (item) => {
    tableHeaderFn();
};

const offHeighths = () => {
    if (myElementRef.value) {
        state.offsetHeight =
            myElementRef.value?.offsetHeight - 180 - searchBox.value?.offsetHeight;
    }
};

const pageChange = (currentPage) => {
    page.value = currentPage;
    getSearch(searchData)
}

const limitChange = (currentLimit) => {
    limit.value = currentLimit;
    getSearch(searchData)
}

// 查询过来的数据
const getSearch = (params = []) => {
    state.userTableLoading = true
    const form = listToMap(toRaw(params), { value: 'value', key: 'field' })
    const requestParams = {
        page: page.value,
        limit: limit.value,
        ...form,
        "d_id": route.query.id,
    }
    pageListApi(JSON.stringify(requestParams)).then(res => {
        maxPage.value = res?.maxPage ?? 0;
        state.userTableData = res?.data?.map(item => {
            return {
                ...item,
                // role_id: listToMap(roleOptions, {})[item.role_id],
                sex: listToMap(sexOptions, {})[item.sex],
                status: listToMap(statusOptions, {})[item.status],
            }
        }) ?? []
    }).catch(e => {
        maxPage.value = 0
        state.userTableData = []
    }).finally(() => {
        state.userTableLoading = false
    })
};

const getEqptSearch = (params = []) => {
    state.eqptTableLoading = true
    const form = listToMap(toRaw(params), { value: 'value', key: 'field' })
    const requestParams = {
        page: page.value,
        limit: limit.value,
        user_id: route.query.id,
        ...form,
        "model": "",
        "status": 99
    }
    getUserDeviceListApi(JSON.stringify(requestParams)).then(res => {
        maxPage.value = res?.maxPage ?? 0;
        state.eqptTableData = res?.data?.map(item => {
            return {
                ...item,
            }
        }) ?? []
    }).catch(() => {
        maxPage.value = 0
        state.eqptTableData = []
    }).finally(() => {
        state.eqptTableLoading = false
    })
};

// 表头筛选
const tableHeaderFn = () => {
    state.userTableHeader = state.userColumn.filter((v) => {
        if (v.show) {
            return v.show == true;
        } else {
            v.show = false;
        }
    });
    state.eqptTableHeader = state.eqptColumn.filter((v) => {
        if (v.show) {
            return v.show == true;
        } else {
            v.show = false;
        }
    });
};

onMounted(() => {
    try {
        nextTick(() => {
            offHeighths();
        });
        window.onresize = () => {
            nextTick(() => {
                offHeighths();
            });
        };
        tableHeaderFn();
        init()
    } catch (error) {

    }
});

defineExpose({ open, state });
</script>

<style lang="less" scoped>
.detail-wrapper {
    display: flex;
    width: 100%;
    height: 100%;
    min-height: 700px;
    overflow: auto;

    .left {
        width: 400px;
        height: 100%;
        padding-left: 10px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .info,
        .click-record,
        .points-record {
            width: calc(100% - 20px);
            height: calc(32% - 20px);
            background-color: #fff;
            border-radius: 6px;
            padding: 10px;
        }

        .info {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            img {
                width: 60px;
                height: 60px;
                border-radius: 50%;
            }

            .name {
                font-size: 28px;
                font-weight: bold;
                color: #333;
                margin: 10px 0;
            }

            .mobile {
                font-size: 18px;
                color: #999;
            }
        }

        .click-record,
        .points-record {
            .title {
                width: 100%;
                height: 40px;
                line-height: 40px;
                font-size: 16px;
            }

            .record {
                height: calc(100% - 40px);
                overflow-y: auto;
            }
        }
    }

    .right {
        width: calc(100% - 430px);
        height: 100%;
        display: flex;
        flex-direction: column;
        padding: 0 10px;

        .overview,
        .my-special {

            background-color: #fff;
            border-radius: 6px;

            .el-tabs {
                height: calc(100% - 2px);
                ::v-deep .el-tabs__content {
                    height: calc(100% - 72px);

                    .el-tab-pane {
                        height: 100%;

                        .table_box {
                            height: calc(100% - 54px);
                            overflow-y: auto;
                        }
                    }
                }
            }
        }

        .overview {
            width: calc(100% - 20px);
            height: 150px;
            padding: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .item {
                width: calc((100% - 20px) / 6);
                height: 80%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                color: #262727;
                cursor: pointer;
                scale: (1);
                transition: all .5s;

                &:hover {
                    scale: (1.2);
                }

                .number {
                    font-size: 26px;
                    color: #409EFF;
                }

                .text {
                    font-size: 14px;
                    color: #58585B;
                }
            }

            .border-right {
                border-right: 1px solid #E6E6E6;
            }
        }

        .my-special {
            height: calc(100% - 160px);
            margin-top: 10px;

            ::v-deep .hc-search {
                background-color: #fff;
            }
        }
    }
}
</style>
